import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollManager() {
  const location = useLocation();

  useEffect(() => {
    const id = location.state && location.state.scrollTo;
    if (id) {
      let attempt = 0;
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        } else if (attempt < 12) {
          attempt += 1;
          setTimeout(tryScroll, 60);
        }
      };
      const raf = requestAnimationFrame(tryScroll);
      return () => cancelAnimationFrame(raf);
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [location]);

  return null;
}
